import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/InfoBlock/Display.tsx
var InfoBlockDisplay = ({ config }) => {
	return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsx("div", {
			className: `${useMemo(() => {
				switch (config.options?.bgStyle) {
					case "info": return "bg-info";
					case "neutral": return "bg-neutral";
					case "positive": return "bg-positive";
					case "caution": return "bg-caution";
					case "critical": return "bg-critical";
					default: return "bg-info";
				}
			}, [config])} rounded border-l-4 p-4`,
			children: /* @__PURE__ */ jsxs("div", {
				className: "flex",
				children: [/* @__PURE__ */ jsx("div", {
					className: "shrink-0",
					children: /* @__PURE__ */ jsx("svg", {
						className: "h-5 w-5",
						xmlns: "http://www.w3.org/2000/svg",
						viewBox: "0 0 20 20",
						fill: "currentColor",
						"aria-hidden": "true",
						children: /* @__PURE__ */ jsx("path", { d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" })
					})
				}), /* @__PURE__ */ jsx("div", {
					className: "ml-3",
					children: /* @__PURE__ */ jsx("p", {
						className: "whitespace-pre-wrap text-sm",
						children: config.options.body
					})
				})]
			})
		})
	});
};
//#endregion
export { InfoBlockDisplay };

//# sourceMappingURL=Display.js.map